/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ObjectifCardDto } from './ObjectifCardDto';
import {
    ObjectifCardDtoFromJSON,
    ObjectifCardDtoFromJSONTyped,
    ObjectifCardDtoToJSON,
    ObjectifCardDtoToJSONTyped,
} from './ObjectifCardDto';
import type { ChartFilterDto } from './ChartFilterDto';
import {
    ChartFilterDtoFromJSON,
    ChartFilterDtoFromJSONTyped,
    ChartFilterDtoToJSON,
    ChartFilterDtoToJSONTyped,
} from './ChartFilterDto';
import type { ChartDataDto } from './ChartDataDto';
import {
    ChartDataDtoFromJSON,
    ChartDataDtoFromJSONTyped,
    ChartDataDtoToJSON,
    ChartDataDtoToJSONTyped,
} from './ChartDataDto';

/**
 * Response containing dashboard statistics
 * @export
 * @interface GetDashboardStatisticsResponse
 */
export interface GetDashboardStatisticsResponse {
    /**
     * Array of objectif (goal) cards to display
     * @type {Array<ObjectifCardDto>}
     * @memberof GetDashboardStatisticsResponse
     */
    goals: Array<ObjectifCardDto>;
    /**
     * Array of charts to display
     * @type {Array<ChartDataDto>}
     * @memberof GetDashboardStatisticsResponse
     */
    charts: Array<ChartDataDto>;
    /**
     * Global filters available for all charts
     * @type {Array<ChartFilterDto>}
     * @memberof GetDashboardStatisticsResponse
     */
    availableFilters?: Array<ChartFilterDto>;
    /**
     * When the statistics were last updated
     * @type {Date}
     * @memberof GetDashboardStatisticsResponse
     */
    lastUpdated?: Date;
}

/**
 * Check if a given object implements the GetDashboardStatisticsResponse interface.
 */
export function instanceOfGetDashboardStatisticsResponse(value: object): value is GetDashboardStatisticsResponse {
    if (!('goals' in value) || value['goals'] === undefined) return false;
    if (!('charts' in value) || value['charts'] === undefined) return false;
    return true;
}

export function GetDashboardStatisticsResponseFromJSON(json: any): GetDashboardStatisticsResponse {
    return GetDashboardStatisticsResponseFromJSONTyped(json, false);
}

export function GetDashboardStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDashboardStatisticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'goals': ((json['goals'] as Array<any>).map(ObjectifCardDtoFromJSON)),
        'charts': ((json['charts'] as Array<any>).map(ChartDataDtoFromJSON)),
        'availableFilters': json['availableFilters'] == null ? undefined : ((json['availableFilters'] as Array<any>).map(ChartFilterDtoFromJSON)),
        'lastUpdated': json['lastUpdated'] == null ? undefined : (new Date(json['lastUpdated'])),
    };
}

export function GetDashboardStatisticsResponseToJSON(json: any): GetDashboardStatisticsResponse {
    return GetDashboardStatisticsResponseToJSONTyped(json, false);
}

export function GetDashboardStatisticsResponseToJSONTyped(value?: GetDashboardStatisticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goals': ((value['goals'] as Array<any>).map(ObjectifCardDtoToJSON)),
        'charts': ((value['charts'] as Array<any>).map(ChartDataDtoToJSON)),
        'availableFilters': value['availableFilters'] == null ? undefined : ((value['availableFilters'] as Array<any>).map(ChartFilterDtoToJSON)),
        'lastUpdated': value['lastUpdated'] == null ? undefined : ((value['lastUpdated']).toISOString()),
    };
}

